import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from './context/auth-context';
import {sha, deploydate} from './ci-sha.json';

export default function Login() {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [coverError, setCoverError] = useState(false);
  const { login, error } = useContext(AuthContext);

  const dynamicCover = `/api/settings/getcover.jpg?t=${new Date().getTime()}`;
  const fallbackCover = "/cover.jpg";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      let result = await login(email, password);
      // console.log(`Login result: `, result);
    } catch (err) {
      console.error('Login failed:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  console.log(`Deploy date: `, deploydate);
  console.log(`Sha: `, sha);

  return (
    <>
      <div className="flex min-h-full flex-col lg:flex-row">
        {/* Mobile top cover - visible only on mobile */}
        <div className="relative h-32 w-full lg:hidden overflow-hidden">
          <img
            alt=""
            src={coverError ? fallbackCover : dynamicCover}
            onError={() => setCoverError(true)}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent to-white/20"></div>
        </div>

        <div className="flex flex-1 flex-col justify-center px-4 py-8 lg:py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>
              <img
                alt="CDP CRM"
                src="/infinity-black.svg"
                className="h-5 w-auto"
              />
              <h2 className="mt-5 text-2xl/9 font-bold tracking-tight text-gray-900">Zaloguj się do swojego konta</h2>
              <p className="mt-2 text-sm/6 text-gray-500">
                CDP CRM
              </p>
            </div>

            <div className="mt-10">
              <div>
                <form onSubmit={handleSubmit} className="space-y-6">
                  
                  {error && (
                    <div className="rounded-md bg-red-50 p-4">
                      <div className="text-sm text-red-700">
                        {error} 
                      </div>
                    </div>
                  )}

                  <div>
                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                      Adres e-mail
                    </label>
                    <div className="mt-2">
                      <input
                        id="email"
                        name="email"
                        type="email"
                        required
                        autoComplete="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="password" className="block text-sm/6 font-medium text-gray-900">
                      Hasło
                    </label>
                    <div className="mt-2">
                      <input
                        id="password"
                        name="password"
                        type="password"
                        required
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                      />
                    </div>
                  </div>

                  <div className="flex items-center justify-between">
                    <div className="flex gap-3">
                      <div className="flex h-6 shrink-0 items-center">
                        <div className="group grid size-4 grid-cols-1">
                          <input
                            id="remember-me"
                            name="remember-me"
                            type="checkbox"
                            className="col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 indeterminate:border-indigo-600 indeterminate:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                          />
                        </div>
                      </div>
                      <label htmlFor="remember-me" className="block text-sm/6 text-gray-900">
                        Zapamiętaj mnie
                      </label>
                    </div>

                  </div>

                  <div>
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:bg-indigo-400 disabled:cursor-not-allowed"
                    >
                      {isSubmitting ? 'Logowanie...' : 'Zaloguj się'}
                    </button>
                  </div>
                  <p className="mt-2 text-sm/6 text-gray-500 text-center">Wersja: {sha}</p>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile bottom cover - visible only on mobile */}
        <div className="relative h-38 w-full lg:hidden overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-t from-transparent to-white/20"></div>
          <img
            alt=""
            src={coverError ? fallbackCover : dynamicCover}
            onError={() => setCoverError(true)}
            className="absolute inset-0 w-full h-full object-cover object-bottom"
          />
        </div>

        {/* Desktop cover - visible only on desktop */}
        <div className="relative hidden w-0 flex-1 lg:block">
          <img
            alt=""
            src={coverError ? fallbackCover : dynamicCover}
            onError={() => setCoverError(true)}
            className="absolute inset-0 size-full object-cover"
          />
        </div>
      </div>
    </>
  )
}
